const PeerQuikPromo: React.FC = () => {
  return (
    <section className="bg-gray-900 text-white py-16 px-4 border-t border-cyan-400/20">
      <div className="max-w-3xl mx-auto">
        <p className="text-sm text-cyan-400 font-semibold mb-3 text-center">PS:</p>
        <h3 className="text-2xl font-bold mb-4 text-center">
          I built this landing (and the automatic delivery system) using my own boilerplate.
        </h3>
        
        <p className="text-lg text-gray-300 mb-6 text-center">
          If you want to build SaaS fast — with auth, Stripe payments, user roles, emails, and admin dashboards already done for you — check out PeerQuik.
        </p>
        
        <div className="text-center">
          <a
            href="/"
            className="inline-block bg-transparent border-2 border-cyan-400 text-cyan-400 hover:bg-cyan-400 hover:text-black font-semibold py-3 px-8 rounded-lg transition-all"
          >
            Learn more about PeerQuik
          </a>
        </div>
      </div>
    </section>
  );
};

export default PeerQuikPromo;